import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import {
  initUsageTracking,
  startView,
  endView,
  normalizePath,
} from "../services/usageTrackingService";

/**
 * Records a page view for every route change (see usageTrackingService).
 * Renders nothing; mounted once inside the Router.
 */
const UsageTracker = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const trackable =
    Boolean(user) && !user.user_metadata?.local_dev && pathname !== "/callback";

  useEffect(() => {
    initUsageTracking();
  }, []);

  useEffect(() => {
    if (!trackable) return undefined;
    const viewId = startView("page", normalizePath(pathname));
    return () => endView(viewId);
  }, [pathname, trackable]);

  return null;
};

export default UsageTracker;
